import styled from '@emotion/styled';
import Theme from 'App.theme';

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const Divider = styled.div`
  border-bottom: 1px solid ${Theme.greys.GREY0};
  margin: 1rem 0;
`;

export const MenuContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const DraftTileContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 1rem;
  row-gap: 1rem;
`;

export const DraftSection = styled.section`
  margin-bottom: 3rem;
`;
